export default __webpack_public_path__ + "img/0263640d2801a5279da2ac01f3936236.png";